var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { LANG_KEY, TOKEN_KEY, USER_KEY } from '../../constants/constants';
import { saveState } from '../../utils';
var withAuthData = function (Component) { return function (_a) {
    var props = __rest(_a, []);
    var queryParams = new URLSearchParams(window.location.search);
    var data = { token: null, userId: null, lang: null };
    if (queryParams.has(TOKEN_KEY)) {
        data.token = queryParams.get(TOKEN_KEY);
        saveState(TOKEN_KEY, queryParams.get(TOKEN_KEY));
        queryParams.delete(TOKEN_KEY);
    }
    if (queryParams.has(USER_KEY)) {
        data.userId = queryParams.get(USER_KEY);
        queryParams.delete(USER_KEY);
    }
    if (queryParams.has(LANG_KEY)) {
        data.lang = queryParams.get(LANG_KEY);
        saveState(LANG_KEY, data.lang);
        queryParams.delete(LANG_KEY);
    }
    if (data.token || data.userId || data.lang)
        window.history.replaceState({}, '', queryParams.toString() !== ''
            ? window.location.pathname + "?" + queryParams
            : window.location.pathname);
    // eslint-disable-next-line react/jsx-props-no-spreading
    return React.createElement(Component, __assign({}, props, data));
}; };
export default withAuthData;
//# sourceMappingURL=withAuthData.js.map